import {patchState, signalStore, withComputed, withMethods, withState} from '@ngrx/signals';
import {
  addEntity,
  removeAllEntities,
  removeEntity,
  setAllEntities,
  setEntity,
  withEntities
} from '@ngrx/signals/entities';
import {DeviceAssociation} from 'src/app/infrastructure/moovement-api/models/asset';
import {computed} from '@angular/core';

const initialState = {
  loading: true
};

export const DeviceAssociationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<DeviceAssociation>(),
  withComputed(({ entities }) => ({
    associatedDeviceIds: computed(() => {
      return new Set(entities().map(a => a.deviceId));
    })
  })),
  withMethods((store) => ({
    reset() {
      patchState(store, removeAllEntities(), initialState);
    },
    setAllDeviceAssociations(associations: DeviceAssociation[]) {
      patchState(store, setAllEntities(associations), { loading: false });
    },
    setDeviceAssociation(association: DeviceAssociation) {
      patchState(store, setEntity(association));
    },
    addDeviceAssociation(association: DeviceAssociation) {
      patchState(store, addEntity(association));
    },
    removeDeviceAssociation(id: string) {
      patchState(store, removeEntity(id));
    }
  })),
  withComputed((store) => ({
    assetIdToDeviceIds: computed(() => {
      const result = new Map<string, string[]>();
      store.entities().forEach(deviceAssociation => {
        const deviceIds = result.get(deviceAssociation.assetId) ?? [];
        deviceIds.push(deviceAssociation.deviceId);
        result.set(deviceAssociation.assetId, deviceIds);
      });

      return result;
    }),
    assetIdToAssocations: computed(() => {
      const result = new Map<string, DeviceAssociation[]>();
      store.entities().forEach(deviceAssociation => {
        const associations = result.get(deviceAssociation.assetId) ?? [];
        associations.push(deviceAssociation);
        result.set(deviceAssociation.assetId, associations);
      });

      return result;
    }),
    deviceIdToAssetId: computed(() => {
      const result = new Map<string, string>();
      store.entities().forEach(deviceAssociation => {
        result.set(deviceAssociation.deviceId, deviceAssociation.assetId);
      });

      return result;
    }),
    deviceIdToAssociation: computed(() => {
      const result = new Map<string, DeviceAssociation>();
      store.entities().forEach(deviceAssociation => {
        result.set(deviceAssociation.deviceId, deviceAssociation);
      });

      return result;
    })
  }))
);
